import React, { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { CustomButton, Textfield } from '../../../_common';
import { ModalForm } from '../interface';
import './AddEditDriverLoadNoteModal.scss';
import Form from 'react-bootstrap/Form';
import { InputGroup } from 'react-bootstrap';

interface AddEditDriverLoadNoteModalProps {
    modalForm: ModalForm;
    editedNote?: any;
    onClickHide: () => void;
    onClickSave: (id: number, note: string) => void;
    show: boolean;
}

const AddEditDriverLoadNoteModal = ({
    show,
    editedNote,
    onClickHide,
    onClickSave,
    modalForm,
}: AddEditDriverLoadNoteModalProps): React.ReactElement => {
    const [selectedId, setSelectedId] = useState(0);
    const [driverLoadNote, setDriverLoadNote] = useState('');
    const isEditForm = modalForm === ModalForm.EDIT_DRIVERLOADNOTE;

    useEffect(() => {
        if (editedNote) {
            setSelectedId(editedNote.id ? editedNote.id : 0);
            setDriverLoadNote(editedNote.notes ? editedNote.notes : ' ');
        } else {
            setSelectedId(0);
            setDriverLoadNote('');
        }
    }, [editedNote]);

    const clearState = (): void => {
        setSelectedId(0);
        setDriverLoadNote('');
    };

    const onSave = (): void => {
        onClickSave(selectedId, driverLoadNote);
        clearState();
    };

    const onCancel = (): void => {
        clearState();
        onClickHide();
    };

    const setSaveButtonStatus = (): boolean => {
        const isNoteValid = driverLoadNote.trim().length > 2 ? true : false;
        return !isNoteValid;
    };

    const onCloseModal = (): void => {
        clearState();
        onClickHide();
    };

    return (
        <Modal show={show} onHide={onCloseModal}>
            <Modal.Header className="AddEditDriverLoadNoteModal-Header">
                <Modal.Title className="AddEditDriverLoadNoteModal-Header-Container">
                    <div className="AddEditDriverLoadNoteModal-Title" style={{ width: '100%' }}>
                        <div style={{ width: '50%', textAlign: 'left' }}>
                            {isEditForm ? 'Edit Note' : 'Create New Note'}
                        </div>
                        <div style={{ width: '50%' }}>
                            <button
                                style={{ float: 'right' }}
                                className="material-icons AddEditDriverLoadNoteModal-X-Button"
                                onClick={onCloseModal}
                            >
                                close
                            </button>
                        </div>
                    </div>
                </Modal.Title>
            </Modal.Header>
            <div className="AddEditDriverLoadNoteModal-Upper-Textarea-Container">
                <div className="AddEditDriverLoadNoteModal-Textarea">
                    <div className="Textarea-FormContainer">
                        <InputGroup className="Textarea-Validation">
                            <Form.Label>
                                {/* <InputGroup.Prepend> */}
                                    <InputGroup.Text className={'Textarea-InputTitle'}></InputGroup.Text>
                                {/* </InputGroup.Prepend> */}
                            </Form.Label>
                            <div className="Textarea-InputRow">
                                <Textfield
                                    label="Note"
                                    value={driverLoadNote || ''}
                                    onChange={(event: any): void => {
                                        const cleanValue = event.target.value.replace(/,/g, '');
                                        setDriverLoadNote(cleanValue);
                                        setSaveButtonStatus();
                                    }}
                                />
                            </div>
                        </InputGroup>
                    </div>
                </div>
            </div>

            <Modal.Footer className="AddEditDriverLoadNoteModal-Footer">
                <CustomButton title="Cancel" isBordered onClick={onCancel}></CustomButton>
                <CustomButton title="Save" isDisabled={setSaveButtonStatus()} onClick={onSave}></CustomButton>
            </Modal.Footer>
        </Modal>
    );
};

export default AddEditDriverLoadNoteModal;

